var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserProgressionAction, AdviserProgressionFormAction, AdviserGlobalAction, AdviserClientObligationsAction, AdviserAdviserObligationsAction, AdviserJobseekerOutcomeAction, } from "../../../../redux/actions/adviser_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { Status } from "../../../../redux/constants/status";
import { getAdviserQuestionnaireProgressWidth } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Progression Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserProgressionQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    //using selector hook to fetch data from the reducer
    var _b = useSelector(function (state) { return state.rootReducer.AdviserQuestionnaireReducer; }), adviserProgressionData = _b.adviserProgressionData, error_adviserProgression = _b.error_adviserProgression, loading = _b.loading, adviserProgressionFormData = _b.adviserProgressionFormData, success_adviserProgression_form = _b.success_adviserProgression_form, status = _b.status, adviserGlobalData = _b.adviserGlobalData, adviserClientObligationsData = _b.adviserClientObligationsData, adviserAdviserObligationsData = _b.adviserAdviserObligationsData;
    useEffect(function () {
        questionnaireTimer.startSection("Adviser Progression");
        if (!adviserProgressionData || adviserProgressionData.length === 0) {
            dispatch(AdviserProgressionAction());
        }
        if (!adviserGlobalData || adviserGlobalData.length === 0) {
            dispatch(AdviserGlobalAction());
        }
        if (!adviserClientObligationsData || adviserClientObligationsData.length === 0) {
            dispatch(AdviserClientObligationsAction());
        }
        if (!adviserAdviserObligationsData || adviserAdviserObligationsData.length === 0) {
            dispatch(AdviserAdviserObligationsAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var isSecondAttempt = !!(quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.adv_questionnaire_one_complete);
    useEffect(function () {
        // adviser_jobseeker_outcome only applies on the adviser's second questionnaire attempt
        if (isSecondAttempt) {
            dispatch(AdviserJobseekerOutcomeAction());
        }
    }, [dispatch, isSecondAttempt]);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Adviser Progression");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        dispatch(AdviserProgressionFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/questionnaire");
    };
    if (success_adviserProgression_form) {
        navigate("/questionnaire/adviserGlobal");
    }
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Adviser Progression", content: "", data: adviserProgressionData, responses: adviserProgressionFormData, loading: status === Status.Loading, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: getAdviserQuestionnaireProgressWidth("adviserProgression", isSecondAttempt) })] })));
}
export default AdviserProgressionQuestionnaire;
